(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvTagsSelector', drvTagsSelector);

    drvTagsSelector.$inject = [];

    /**
     * @ngdoc directive
     * @name drvTagsSelector
     * 
     * @description
     * Select control used for selecting multiple tags
     * 
     * # Scope Properties
     * {array} value - The selected tags.
     * {array} tags - List of tags which can be selected.
     * {object} control - Optional. Provide an object and it will have the following added to it:
     *   - {function} refresh - Refreshes the tags
     * {bool} documentTemplateLink - Should the tag value include the property 'DocumentTemplateId'. Optional.
     * {bool} activityLink - Should the tag value include the property 'ActivityId'. Optional.
     * {bool} idMode - True if the 'value' is an array of tag ids (numbers), instead of tag objects. Optional. Default false.
     * {bool} disabled
     */
    function drvTagsSelector() {
        return {
            templateUrl: 'app/tag/tags-selector.tmpl.html',
            scope: {},
            controller: drvTagsSelectorCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                value: '=',
                tags: '=',
                control: '=',
                documentTemplateLink: '<?',
                activityLink: '<?',
                idMode: '<?',
                disabled: '<?'
            }
        };
    }

    drvTagsSelectorCtrl.$inject = ['$scope'];

    function drvTagsSelectorCtrl($scope) {
        /* jshint validthis:true */
        var drvCtrl = this;
        drvCtrl.valueProperties = ['TagId', 'Id'];
        drvCtrl.tagList = [];
        drvCtrl.selectedTags = [];
        var tagsInitialised = false;

        activate();

        function activate() {
            if (drvCtrl.documentTemplateLink) {
                drvCtrl.valueProperties.push('DocumentTemplateId');
            }

            if (drvCtrl.activityLink) {
                drvCtrl.valueProperties.push('ActivityId');
            }

            if (!_.isNil(drvCtrl.control)) {
                drvCtrl.control.refresh = refresh;
            }

            $scope.$watch('drvCtrl.value', function (newVal, oldVal) {
                initialiseTags();
                updateSelectedTagsFromValue();
            });

            $scope.$watch('drvCtrl.tags', function (newVal, oldVal) {
                tagsInitialised = false;
                initialiseTags();
            });

            $scope.$watch('drvCtrl.selectedTags', function (newVal) {
                updateValueFromSelectedTags();
            });
        }

        function updateValueFromSelectedTags() {
            if (tagsInitialised) {
                drvCtrl.value.length = 0;

                if (isIdMode()) {
                    _.forEach(drvCtrl.selectedTags, function (tag) {
                        drvCtrl.value.push(tag.TagId);
                    });
                } else {

                    _.forEach(drvCtrl.selectedTags, function (tag) {
                        drvCtrl.value.push(tag);
                    });
                }
            }
        }
        
        function updateSelectedTagsFromValue() {
            if (tagsInitialised) {
                drvCtrl.selectedTags.length = 0;

                if (isIdMode()) {
                    _.forEach(drvCtrl.value, function (tagId) {
                        var selectedTag = _.find(drvCtrl.tagList, 'TagId', tagId);
                        if (!_.isNil(selectedTag)) {
                            drvCtrl.selectedTags.push(selectedTag);
                        }
                    });
                } else {

                    _.forEach(drvCtrl.value, function (tag) {
                        var selectedTag = _.find(drvCtrl.tagList, 'TagId', tag.TagId);
                        if (!_.isNil(selectedTag)) {
                            drvCtrl.selectedTags.push(selectedTag);
                        }
                    });
                }
            }
        }

        function isIdMode() {
            return !_.isNil(drvCtrl.idMode) && drvCtrl.idMode;
        }

        function refresh() {
            tagsInitialised = false;
        }

        /**
         * The tags displayed in the selector are a combination of the data source (drvCtrl.tags), and
         * the tags already selected (drvCtrl.value).
         * The 'Id' of any selected tags is copied onto the data source because that's a record id for
         * the tag "link" in the database.
         * Additionally, 'DocumentTemplateId' or 'ActivityId' may be copied to the data source for
         * much the same reason.
         * See C# models DocumentTemplateTagLink and ActivityTagLink to get a better sense of what's
         * going on here.
         */
        function initialiseTags() {
            if (_.isNil(drvCtrl.value) || _.isNil(drvCtrl.tags) || tagsInitialised) {
                return;
            }

            var tagList = _.map(drvCtrl.tags, function (tag) {
                var result = {
                    TagId: tag.Id,
                    Name: tag.Name,
                    ForegroundColour: tag.ForegroundColour,
                    BackgroundColour: tag.BackgroundColour
                };

                if (!isIdMode()) {
                    // When not in 'id mode', additional properties are added to the tag data source

                    var selectedTag = _.find(drvCtrl.value, function (at) {
                        return at.TagId === tag.Id;
                    });

                    if (!_.isNil(selectedTag)) {
                        // This tag was already selected, copy 'Id' properties to the data source
                        result.Id = selectedTag.Id;

                        if (drvCtrl.documentTemplateLink) {
                            result.DocumentTemplateId = selectedTag.DocumentTemplateId;
                        }

                        if (drvCtrl.activityLink) {
                            result.ActivityId = selectedTag.ActivityId;
                        }
                    } else {
                        // This tag was NOT already selected, set default 'Id' properties on the data source
                        result.Id = 0;

                        if (drvCtrl.documentTemplateLink) {
                            result.DocumentTemplateId = 0;
                        }

                        if (drvCtrl.activityLink) {
                            result.ActivityId = 0;
                        }
                    }
                }

                return result;
            });

            drvCtrl.tagList = _.sortBy(tagList, function (n) { return n.Name; });
            tagsInitialised = true;
            updateSelectedTagsFromValue();
        }
    }
})();